import Swiper from 'swiper';
import { A11y, Autoplay, Scrollbar } from 'swiper/modules';
import { initVisuals } from './visuals';

Swiper.use([A11y, Autoplay, Scrollbar]);

jQuery(document).ready(function ($) {

    initVisuals();

    const desktop = window.matchMedia('(min-width: 1230px)');
    const $portfolio = $('.section__portfolio');
    let portfolioHTML = null;

    function initLazyVideos() {
        const lazyVideos = document.querySelectorAll('video[data-lazy-video]');

        if (!lazyVideos.length) return;

        const showVideo = function (video) {
            if (desktop.matches) {
                video.play().catch(function () {});
                return;
            }

            if (video.hasAttribute('data-has-poster')) return;

            video.preload = 'metadata';
            video.src = video.src.split('#')[0] + '#t=0.001';
        };

        if (!('IntersectionObserver' in window)) {
            lazyVideos.forEach(showVideo);
            return;
        }

        const videoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                showVideo(entry.target);
                observer.unobserve(entry.target);
            });
        }, { rootMargin: '200px' });

        lazyVideos.forEach(function (video) { videoObserver.observe(video); });
    }

    let portfolioSwiper = null;

    function layoutPortfolio() {
        if (!$portfolio.length) return;

        const $container = $portfolio.find('.container');

        if (!desktop.matches && !portfolioSwiper) {
            portfolioHTML ??= window.mcPortfolioHTML ?? $container.html();

            if (!$container.find('.swiper-wrapper').length) {
                const $items = $container.find('.section__portfolio-item').detach().addClass('swiper-slide');
                $container.find('.section__portfolio-right').empty().addClass('swiper').append($('<div class="swiper-wrapper"></div>').append($items));
            }

            portfolioSwiper = new Swiper($container.find('.section__portfolio-right')[0], {
                slidesPerView: 1.2,
                spaceBetween: 16,
                grabCursor: true,
            });
        } else if (desktop.matches && portfolioHTML) {
            portfolioSwiper?.destroy(true, true);
            portfolioSwiper = null;
            $container.html(portfolioHTML);
            portfolioHTML = null;
            initLazyVideos();
        }
    }

    layoutPortfolio();
    desktop.addEventListener('change', layoutPortfolio);

    const floatingCta = document.querySelector('.floating-cta');
    const footer = document.querySelector('.footer');

    if (floatingCta && footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
            floatingCta.classList.toggle('is-hidden', entries[0].isIntersecting);
        }).observe(footer);
    }

    const header = document.querySelector('.header');
    let lastScrollY = window.scrollY;
    let headerTicking = false;

    const updateHeader = function () {
        const scrollY = window.scrollY;
        const goingDown = scrollY > lastScrollY;

        headerTicking = false;
        header.classList.toggle('is-scrolled', scrollY > 10);

        if (!document.body.classList.contains('has-mobile-menu') && Math.abs(scrollY - lastScrollY) > 6) {
            header.classList.toggle('is-hidden', goingDown && scrollY > header.offsetHeight);
        }

        lastScrollY = scrollY;
    };

    if (header) {
        $(window).on('scroll', function () {
            if (headerTicking) return;
            headerTicking = true;
            requestAnimationFrame(updateHeader);
        });

        updateHeader();
    }

    $('.scan').each(function () {
        const $scan = $(this);
        const $form = $scan.find('.scan__form');
        const $steps = $scan.find('.scan__step');
        const $segments = $scan.find('.scan__progress span');
        const $prev = $scan.find('.scan__prev');
        const $next = $scan.find('.scan__next');
        const total = $steps.length;
        const arrow = ' <span aria-hidden="true">&rarr;</span>';
        let current = 0;

        const escape = function (value) {
            return $('<div>').text(value).html();
        };

        const answers = function () {
            return $steps.not('.scan__step--result').map(function () {
                const $step = $(this);
                const $range = $step.find('.scan__range');
                const values = $range.length
                    ? [$range.data('options')[parseInt($range.val(), 10)]]
                    : $step.find('input:checked').map(function () { return this.value; }).get();

                return { question: $step.data('question'), values: values };
            }).get();
        };

        const updateRange = function ($range) {
            const options = $range.data('options');
            const index = parseInt($range.val(), 10);

            const $value = $range.closest('.scan__step').find('.scan__value');

            $range[0].style.setProperty('--fill', (index / Math.max(1, options.length - 1) * 100) + '%');

            if ($value.text() !== options[index]) {
                $value.text(options[index]).removeClass('is-changing');
                void $value[0].offsetWidth;
                $value.addClass('is-changing');
            }
            $range.siblings('.scan__ticks').find('span').removeClass('is-active').eq(index).addClass('is-active');
        };

        const fillBar = function ($bar, percentage, base) {
            if (!$bar.children().length) {
                $bar.html('<span></span>'.repeat(24));
            }

            const on = Math.round(percentage / 100 * 24);
            const from = base ? Math.round(base / 100 * 24) : 0;

            $bar.children().removeClass('is-on is-base').each(function (index) {
                const $segment = $(this);
                setTimeout(function () {
                    $segment.toggleClass('is-base', index < from).toggleClass('is-on', index >= from && index < on);
                }, 300 + index * 30);
            });
        };

        const renderResult = function () {
            const data = answers();
            const pains = (data[0] ? data[0].values : []).concat(data[2] ? data[2].values : []);
            const goals = data[1] ? data[1].values : [];
            const position = Math.max(20, 70 - pains.length * 5);
            const potential = Math.min(96, position + 18 + goals.length * 5);
            const $result = $steps.filter('.scan__step--result');

            fillBar($result.find('[data-meter="current"] .scan__bar'), position);
            fillBar($result.find('[data-meter="potential"] .scan__bar'), potential, position);
            $result.find('.scan__chip').text('+' + Math.round((potential - position) / position * 100) + '%');
        };

        const show = function (index) {
            const $step = $steps.eq(index);

            current = index;
            $steps.attr('hidden', true);
            $step.removeAttr('hidden');
            $segments.each(function (segment) { $(this).toggleClass('is-done', segment <= index); });
            $scan.find('.scan__current').text(index + 1);
            $scan.find('.scan__percentage').text(Math.round((index + 1) / total * 100) + '%');
            $prev.prop('hidden', index === 0);
            $scan.find('.scan__nav').toggleClass('is-final', index === total - 1);
            $next.html((index === total - 1 ? 'Verstuur mijn scan' : (index === total - 2 ? 'Bekijk mijn uitkomst' : 'Volgende')) + arrow);

            if ($step.hasClass('scan__step--result')) {
                renderResult();
            }

            if ($scan[0].getBoundingClientRect().top < 0) {
                $scan[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        const analyse = function () {
            const $loading = $scan.find('.scan__loading');
            const $items = $loading.find('li').removeClass('is-done');
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            $steps.attr('hidden', true);
            $scan.find('.scan__nav').attr('hidden', true);
            $loading.removeAttr('hidden').find('.scan__loading-bar').removeClass('is-running');
            void $loading[0].offsetWidth;
            $loading.find('.scan__loading-bar').addClass('is-running');

            $items.each(function (index) {
                const $item = $(this);
                setTimeout(function () { $item.addClass('is-done'); }, reduced ? 0 : 500 + index * 600);
            });

            setTimeout(function () {
                $loading.attr('hidden', true);
                $scan.find('.scan__nav').removeAttr('hidden');
                show(total - 1);
            }, reduced ? 300 : 2400);
        };

        const validate = function () {
            const $step = $steps.eq(current);
            const valid = !$step.find('.scan__options').length || $step.find('input:checked').length > 0;

            $step.find('.scan__error').prop('hidden', valid);

            return valid;
        };

        const submit = function () {
            const $error = $steps.eq(current).find('.scan__error');
            const field = function (name) { return $.trim($form.find('[name="' + name + '"]').val() || ''); };

            if (!field('name') || !field('company') || !field('phone') || !/^\S+@\S+\.\S+$/.test(field('email'))) {
                $error.text('Vul je naam, bedrijfsnaam, telefoonnummer en een geldig e-mailadres in.').prop('hidden', false);
                return;
            }

            $error.prop('hidden', true);
            $next.prop('disabled', true);

            $.post(ajaxURL, {
                action: $scan.data('action'),
                nonce: $scan.data('nonce'),
                page_id: $scan.data('page'),
                answers: JSON.stringify(answers()),
                name: field('name'),
                email: field('email'),
                phone: field('phone'),
                company: field('company'),
                website: field('website'),
                website_url: field('website_url'),
            }).done(function () {
                $form.add($scan.find('.scan__top')).attr('hidden', true);
                $scan.find('.scan__success').removeAttr('hidden');
                $scan[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }).fail(function (xhr) {
                const message = xhr.responseJSON && xhr.responseJSON.data ? xhr.responseJSON.data.message : '';
                $error.text(message || 'Er ging iets mis. Probeer het opnieuw.').prop('hidden', false);
            }).always(function () {
                $next.prop('disabled', false);
            });
        };

        $scan.find('.scan__range').each(function () {
            updateRange($(this));
        }).on('input', function () {
            updateRange($(this));
        });

        $steps.on('change', 'input', function () {
            $(this).closest('.scan__step').find('.scan__error').prop('hidden', true);
        });

        $prev.on('click', function () {
            show(current - 1);
        });

        $form.on('submit', function (event) {
            event.preventDefault();

            if (!validate()) return;

            if (current === total - 2) {
                analyse();
                return;
            }

            if (current < total - 1) {
                show(current + 1);
                return;
            }

            submit();
        });

        show(0);
    });

    const pageTitle = document.title;

    document.addEventListener('visibilitychange', function () {
        document.title = document.hidden ? 'Kom terug! We missen je' : pageTitle;
    });

    const $menuToggle = $('.header__toggle');
    const $mobileMenu = $('#mobile-menu');

    function setMobileMenu(open) {
        $menuToggle.attr({ 'aria-expanded': open, 'aria-label': open ? 'Menu sluiten' : 'Menu openen' });
        $mobileMenu.toggleClass('is-open', open);
        $('body').toggleClass('has-mobile-menu', open);
    }

    $menuToggle.on('click', function () {
        setMobileMenu($(this).attr('aria-expanded') !== 'true');
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') setMobileMenu(false);
    });

    desktop.addEventListener('change', function () {
        setMobileMenu(false);
    });

    function initMobileMotion() {
        if (desktop.matches || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const revealObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            });
        }, { rootMargin: '0px 0px -10% 0px' });

        const wordmark = document.querySelector('.footer__wordmark');

        if (wordmark) {
            wordmark.classList.add('reveal-letters');

            new IntersectionObserver(function (entries, observer) {
                if (!entries[0].isIntersecting) return;
                wordmark.classList.add('is-visible');
                observer.disconnect();
            }, { threshold: 0.2 }).observe(wordmark);
        }

        $('.section__portfolio h2, .section__customers, .section__services h2, .section__reviews-header, .section__blogs h2, .section__blogs .blog').each(function () {
            this.classList.add('reveal');
            revealObserver.observe(this);
        });

        const stackItems = document.querySelectorAll('.section__services-item');

        if (stackItems.length < 2) return;

        let ticking = false;

        const updateStack = function () {
            ticking = false;

            stackItems.forEach(function (item, i) {
                const next = stackItems[i + 1];

                if (!next) return;

                const overlap = item.getBoundingClientRect().bottom - next.getBoundingClientRect().top;
                const progress = Math.min(Math.max(overlap / item.offsetHeight, 0), 1);

                item.style.transform = 'scale(' + (1 - progress * 0.06) + ')';
            });
        };

        $(window).on('scroll resize', function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(updateStack);
        });

        updateStack();
    }

    initMobileMotion();

    let swiperCustomers = new Swiper(".swiper__customers", {
        slidesPerView: "auto",
        spaceBetween: 48,
        a11y: {
            slideRole: null,
            slideLabelMessage: null,
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
    });

    // Swiper zet role="group" + aria-label "1 / 11" op de logo-links; dat is
    // ongeldige ARIA op een <a> en overschrijft de partnernaam uit de PHP-template
    document.querySelectorAll('.swiper__customers .swiper-slide').forEach(function (el) {
        if (el.getAttribute('role') === 'group') el.removeAttribute('role');
        if (/^\d+ \/ \d+$/.test(el.getAttribute('aria-label') || '')) {
            if (el.dataset.label) {
                el.setAttribute('aria-label', el.dataset.label);
            } else {
                el.removeAttribute('aria-label');
            }
        }
    });

    const loadScript = function (src) {
        return new Promise(function (resolve, reject) {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    };

    let desktopMotionLoaded = false;

    const loadDesktopMotion = function () {
        if (!desktop.matches || desktopMotionLoaded) return;

        desktopMotionLoaded = true;

        loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js')
            .then(function () { return loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js'); })
            .then(initDesktopMotion)
            .catch(function () {});
    };

    function initDesktopMotion() {
        gsap.registerPlugin(ScrollTrigger);
        gsap.matchMedia().add('(min-width: 1230px)', function () {

            const letters = gsap.utils.toArray('.footer__wordmark path');

            if (letters.length) {
                gsap.from(letters, {
                    yPercent: 110,
                    opacity: 0,
                    duration: 0.8,
                    ease: 'power3.out',
                    stagger: 0.07,
                    scrollTrigger: {
                        trigger: '.footer__wordmark',
                        start: 'top 95%',
                        toggleActions: 'play none none reverse',
                    }
                });
            }

            $('[data-animation="appear-title"]').each(function () {
                const $el = $(this);

                if (!$el.find('.line').length) {
                    const words = $el.html().split(/(\s+)/);
                    $el.empty();

                    words.forEach(function (word) {
                        $el.append(word.trim() === '' ? document.createTextNode(word) : $('<div class="line" style="display:inline-block;"></div>').html(word));
                    });
                }

                gsap.fromTo($el.find('.line'), { y: 20, opacity: 0 }, {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    stagger: 0.1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: this,
                        start: 'top 90%',
                        toggleActions: 'play none none none'
                    }
                });
            });

            const customersEl = document.querySelector('.swiper__customers');

            if (customersEl) {
                gsap.fromTo(customersEl, { scale: 0.65 }, {
                    scale: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: customersEl,
                        start: 'top bottom',
                        end: 'top center',
                        scrub: true
                    }
                });
            }

            const $items = $('.section__services-item');
            const total = $items.length;
            const offset = 48;

            $items.each(function (i) {
                gsap.set(this, { zIndex: i + 1 });

                if (i === total - 1) return;

                ScrollTrigger.create({
                    trigger: this,
                    start: `top-=${offset * i} top+=80`,
                    endTrigger: $items[total - 1],
                    end: `top-=${offset * (total - 1)} top+=80`,
                    pin: true,
                    pinSpacing: false,
                });

                gsap.to(this, {
                    scale: 1 - (total - i) * 0.03,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: $items[i + 1],
                        start: 'top bottom',
                        end: `top-=${offset * i} top+=80`,
                        scrub: true,
                    },
                });
            });

            if (document.querySelector('.section__services-stack')) {
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.section__services-stack',
                        start: 'top 20%',
                        end: 'bottom 80%',
                        scrub: 1,
                    }
                });

                ['#g_mediacaring', '#n_mediacaring', '#i_mediacaring', '#r_mediacaring', '#a_mediacaring', '#c_mediacaring', '#aa_mediacaring', '#ii_mediacaring', '#dd_mediacaring', '#ee_mediacaring', '#mm_mediacaring'].forEach(function (id) {
                    if (document.querySelector(id)) tl.to(id, { fill: 'rgba(0,0,0,1)' });
                });
            }

        });
    }

    loadDesktopMotion();
    desktop.addEventListener('change', loadDesktopMotion);

    if (document.querySelector('.swiper__testimonials')) {
        new Swiper('.swiper__testimonials', {
            slidesPerView: 1.15,
            spaceBetween: 16,
            grabCursor: true,
            breakpoints: {
                768: { slidesPerView: 2.2, spaceBetween: 24 },
                1230: { slidesPerView: 3.5, spaceBetween: 24 },
            },
        });
    }

    let swiperReviews = new Swiper(".swiper__reviews", {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    });

    // Portfolio-video's lazy afspelen
    initLazyVideos();

    // De door PHP uitgestelde CF7-reCAPTCHA-scripts (3x ±375 KB + 1,5s CPU)
    // pas injecteren zodra het contactformulier bijna in beeld is
    const contactSection = document.querySelector('.section__contact') || document.querySelector('.wpcf7');
    if (contactSection && window.mcDeferredRecaptcha && window.mcDeferredRecaptcha.length) {
        const loadRecaptcha = function () {
            if (window.__recaptchaLoaded) return;
            window.__recaptchaLoaded = true;

            // Volgorde behouden: eerst api.js, daarna de wpcf7-integratie
            const queue = window.mcDeferredRecaptcha.slice();
            (function next() {
                const item = queue.shift();
                if (!item) return;

                (item.inline || []).forEach(function (code) {
                    const inlineScript = document.createElement('script');
                    inlineScript.text = code;
                    document.head.appendChild(inlineScript);
                });

                if (!item.src) return next();
                const script = document.createElement('script');
                script.src = item.src;
                script.async = true;
                script.onload = next;
                script.onerror = next;
                document.head.appendChild(script);
            })();
        };

        if ('IntersectionObserver' in window) {
            const recaptchaObserver = new IntersectionObserver(function (entries) {
                if (entries.some(function (entry) { return entry.isIntersecting; })) {
                    loadRecaptcha();
                    recaptchaObserver.disconnect();
                }
            }, { rootMargin: '600px' });
            recaptchaObserver.observe(contactSection);

            // Vangnet: ook laden zodra iemand het formulier aanraakt
            document.addEventListener('focusin', function onFocus(e) {
                if (e.target.closest && e.target.closest('.wpcf7')) {
                    loadRecaptcha();
                    document.removeEventListener('focusin', onFocus);
                }
            });
        } else {
            loadRecaptcha();
        }
    }

    $('.section__faq-item summary').on('click', function (e) {
        e.preventDefault();

        const $item = $(this).parent();
        const $answer = $item.find('.section__faq-answer');

        if ($item.prop('open')) {
            $answer.stop(true).slideUp(300, function () {
                $item.prop('open', false);
            });
        } else {
            $item.prop('open', true);
            $answer.hide().stop(true).slideDown(300);
        }
    });

    const $blogPreview = $('.section__blogs-preview');

    $('.section__blogs .blog[data-thumb]')
        .on('mouseenter', function () {
            $blogPreview.attr('src', $(this).data('thumb')).addClass('is-visible');
        })
        .on('mousemove', function (e) {
            $blogPreview.css({ '--x': (e.clientX + 24) + 'px', '--y': (e.clientY - 90) + 'px' });
        })
        .on('mouseleave', function () {
            $blogPreview.removeClass('is-visible');
        });

});